import 'waypoints/lib/jquery.waypoints';
import 'waypoints/lib/shortcuts/inview';
import 'waypoints/lib/shortcuts/sticky';



// WEBPACK FOOTER //
// ./scripts/autoload/_waypoints.js